import './App.css';
import {Grid} from '@mui/material';
import PaginaLanding from "./PaginaLanding/PaginaLanding";
import '@fontsource/inter/400.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/800.css'
import '@fontsource/inter/900.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import {useEffect} from "react";

function App() {


    useEffect(() => {
        AOS.init({
            duration: 1000, // Duración de la animación en ms
            once: true,    // ¿Animar solo la primera vez que se ve?
        });
    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display:'none'}}>SyC Tienda Deportiva</h1>
            <h2 style={{display:'none'}}>Ropa Deportiva</h2>
            <h2 style={{display:'none'}}>Zapatos Deportivos</h2>
            <h2 style={{display:'none'}}>Articulos Deportivos</h2>
            <h2 style={{display:'none'}}>Tienda de Marca Deportiva</h2>

            <PaginaLanding/>

        </Grid>
    );
}

export default App;
